import axios from "axios";

// React automatically sets NODE_ENV to 'development' on local and 'production' on Vercel
const isLocal = process.env.NODE_ENV === 'development';
const BACKEND_URL = isLocal
    ? "http://localhost:8080"
    : "https://axerraweb.space";

export const API = `${BACKEND_URL}/api`;

// Separate token keys for admin vs client
const ADMIN_TOKEN_KEY = "axerra_admin_token";
const CLIENT_TOKEN_KEY = "axerra_client_token";

export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_KEY);
export const setAdminToken = (t) => localStorage.setItem(ADMIN_TOKEN_KEY, t);
export const clearAdminToken = () => localStorage.removeItem(ADMIN_TOKEN_KEY);

export const getClientToken = () => localStorage.getItem(CLIENT_TOKEN_KEY);
export const setClientToken = (t) => localStorage.setItem(CLIENT_TOKEN_KEY, t);
export const clearClientToken = () => localStorage.removeItem(CLIENT_TOKEN_KEY);

// Back-compat
export const getToken = getAdminToken;
export const setToken = setAdminToken;
export const clearToken = clearAdminToken;

// Convert a relative /api/uploads/xxx URL to a full URL for <img>
export function assetUrl(url) {
    if (!url) return "";
    if (/^https?:\/\//i.test(url)) return url;
    if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
    if (url.startsWith("/uploads/")) return `${BACKEND_URL}/api${url}`;
    return url;
}

// Public (no auth)
export const api = axios.create({ baseURL: API, timeout: 20000 });

// Admin
export const authApi = axios.create({ baseURL: API, timeout: 20000 });
authApi.interceptors.request.use((config) => {
    const token = getAdminToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});
authApi.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            clearAdminToken();
            if (typeof window !== "undefined" && window.location.pathname.startsWith("/admin") && !window.location.pathname.startsWith("/admin/login")) {
                window.location.href = "/admin/login";
            }
        }
        return Promise.reject(err);
    },
);

// Client
export const clientApi = axios.create({ baseURL: API, timeout: 20000 });
clientApi.interceptors.request.use((config) => {
    const token = getClientToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});
clientApi.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            clearClientToken();
            if (typeof window !== "undefined" && window.location.pathname.startsWith("/portal")) {
                window.location.href = "/login";
            }
        }
        return Promise.reject(err);
    },
);

export function apiError(err, fallback = "Something went wrong. Please try again.") {
    const detail = err?.response?.data?.detail;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((d) => (typeof d?.msg === "string" ? d.msg : JSON.stringify(d))).join(" · ");
    if (err?.response?.data?.message) return err.response.data.message;
    if (err?.response?.data?.error) return err.response.data.error;
    return err?.message || fallback;
}
